import styled from 'styled-components';
import colors from 'constants/colors';

export const Head = styled.div`
  font-size: 22px;
  font-weight: 600;
  color: ${colors.green};
`;

export const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
  padding: 16px;
  height: 100%;
`;

export const Content = styled.div`
  width: 500px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;

  .text {
    color: ${colors.white};
    margin: 25px 0 15px 0;
  }

  .list {
    margin-bottom: 20px;
  }
`;

export const Row = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  column-gap: 16px;
  margin: 24px 0 0 0;
`;

export const Footer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  padding-top: 20px;

  .buttonContainer {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
`;
